import { api } from '@api/api2';

export const getIntercomModels = () => api.no_vers('post', 'intercom/get-intercom-model');
